"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowActions = exports.RowAction = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RedPanda UI - RowAction / RowActions Components
 * 表格操作欄（docs/介面優化.md §3-5）
 * 所有動作同一個主題色（同連結，一眼看得出能點），只有刪除用紅色；取代「查看藍／編輯綠／複製紫」的彩虹連結。
 * 2026-10-15 由中性灰改主題色：灰字容易被當成說明文字（使用者回報）
 */
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../utils");
exports.RowAction = react_1.default.forwardRef(({ tone = 'default', className, type = 'button', ...props }, ref) => ((0, jsx_runtime_1.jsx)("button", { ref: ref, type: type, className: (0, utils_1.cn)('text-sm font-medium transition-colors disabled:opacity-50 disabled:pointer-events-none', tone === 'danger'
        ? 'text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300'
        : 'text-accent hover:text-brand-700 dark:hover:text-brand-300', className), ...props })));
exports.RowAction.displayName = 'RowAction';
/** 操作欄容器：動作之間固定間距；超過 3 個動作請改用「⋯」選單 */
const RowActions = ({ className, ...props }) => (
// w-fit＋cursor-pointer：滑過按鈕間的空隙時游標不切回箭頭（Windows 快速切換會畫出半截游標）
(0, jsx_runtime_1.jsx)("div", { className: (0, utils_1.cn)('flex w-fit items-center gap-3 cursor-pointer', className), ...props }));
exports.RowActions = RowActions;
exports.RowActions.displayName = 'RowActions';
